module.exports = __webpack_public_path__ + "static/img/1.c4782255.png";